import * as WorldActions from "@mywvglobal-shared/mywv-shared/action/worldAction";
import * as sponsorshipsDataAction from "@mywvglobal-shared/mywv-shared/action/sponsorshipsDataAction";
import * as getProjectCelebrationDetailsAction from "@mywvglobal-shared/mywv-shared/action/getProjectCelebrationDetailsAction";
import * as ChildHomeAction from "@mywvglobal-shared/mywv-shared/action/childHomeAction";
import * as ChildProfileAction from "@mywvglobal-shared/mywv-shared/action/childProfileAction";
import * as GiveAction from "@mywvglobal-shared/mywv-shared/action/giveAction";
import * as MyGivingsAction from "@mywvglobal-shared/mywv-shared/action/myGivingsActions";
import * as CommunityAction from "@mywvglobal-shared/mywv-shared/action/communityAction";
import * as StationAction from "@mywvglobal-shared/mywv-shared/action/stationAction";
import * as getChosenRevealDetailsAction from "@mywvglobal-shared/mywv-shared/action/getChosenRevealDetailsAction";
import * as UserDetailsAction from "@mywvglobal-shared/mywv-shared/action/userDetailsAction";
import * as getCookiePreferenceAction from "@mywvglobal-shared/mywv-shared/action/getCookiePreferenceAction";
import * as EditPhoneAction from "@mywvglobal-shared/mywv-shared/action/editPhoneNumberAction";
import * as updateCookiePreferenceAction from "@mywvglobal-shared/mywv-shared/action/updateCookiePreferenceAction";
import * as ImageConvertAction from "@mywvglobal-shared/mywv-shared/action/getImageConvertAction";
import * as DroppedChildAction from "@mywvglobal-shared/mywv-shared/action/droppedChildAction";
import * as PastSponsoredChildAction from "@mywvglobal-shared/mywv-shared/action/pastSponsoredChildAction";
import * as EditPictureAction from "@mywvglobal-shared/mywv-shared/action/editProfilePictureAction";
import * as PrivacyAction from "@mywvglobal-shared/mywv-shared/action/privacyAction";
import * as GetStoriesAction from "@mywvglobal-shared/mywv-shared/action/exploreStoriesAction";
import * as UpdateSupportNotificationAction from "@mywvglobal-shared/mywv-shared/action/updateSupporterContactDetailsNotificationAction";
import * as UpdateNotificationAction from "@mywvglobal-shared/mywv-shared/action/UpdateNotificationMediumPreferenceAction";
import * as GetHelpAction from "@mywvglobal-shared/mywv-shared/action/getHelpAction";
import * as UpdateChosenChildExploreStatusAction from "@mywvglobal-shared/mywv-shared/action/updateChosenChildExploreStatusAction";
import moment from "moment/moment";
import { BaseRepository } from "./BaseRepository.js";
import  { ConnectRepository } from "./ConnectRepository.js";
// import {getFieldDropDays} from "../utilities/fieldDropEligibilityUtils.js";

/**
 * A repository for handling all API calls in the application.
 * It centralizes the logic for making requests and dispatching Redux actions.
 */
class ApiRepository extends BaseRepository {
  constructor(dispatch, loginReducer, persistItemsReducer) {
    super(dispatch, loginReducer, persistItemsReducer);
    this.connectRepository = new ConnectRepository(dispatch, loginReducer, persistItemsReducer);
    /// Future repositories can be initialized here as above
  }

  /** 
   * Fetches sponsorship and child coordinates data for the current donor and dispatches relevant actions.
   */
  async getSponsorChildCoordinates() {
    if (!this.baseURL) return;
    this.dispatch(WorldActions.clearWorldReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(WorldActions.getSponsorAndChildCoordinates(requestPayload));
  }

  /**
   * Fetches sponsorships data for the current donor and dispatches relevant actions.
   */
  async getSponsorshipsData() {
    if (!this.baseURL) return;
    this.dispatch(sponsorshipsDataAction.clearSponsorshipsDataReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
      fdNumberofDays: this.loginReducer?.getSOConfiguration?.fdNumberofDays ,
      pastSponsoredChildDisplayDuration: this.loginReducer?.getSOConfiguration?.pastSponsoredChildDisplayDuration
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(sponsorshipsDataAction.getSponsorshipsDataRequest(requestPayload));
  }

  /**
   * Fetches and dispatches project celebration details for a given child code.
   */
  async getProjectCelebrationData(childCode) {
    if (!this.baseURL) return;
    this.dispatch(getProjectCelebrationDetailsAction.clearProjectCelebrationDetailsReducer());
    this.dispatch(getProjectCelebrationDetailsAction.showProjectCelebrationDetailsReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
      emailID: this.persistItemsReducer?.emailID,
      childCode: childCode, // The component will pass the decrypted childCode
      placeHolders: this.loginReducer?.getSOConfiguration?.faqFormatter?.placeHolders,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(getProjectCelebrationDetailsAction.getProjectCelebrationDetailsRequest(requestPayload));
  }

  /**
   * Fetches and dispatches child home data for a given child code.
   */
  async getChildHomeData(childCode) {
    if (!this.baseURL) return;
    this.dispatch(ChildHomeAction.clearChildHomeReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      childCode: childCode,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
      shortLanguageCode: this.persistItemsReducer?.selectedSOData?.shortLanguageCode,
    };
    const requestPayload = { baseURL: this.baseURL, reqBody, reqHeaders: await this.getHeaders() };
    this.dispatch(ChildHomeAction.getChildHomeRequest(requestPayload));
  }

  /**
   * Fetches the profile information for a child based on the provided child code.
   */
  async getChildProfile(childCode) {
    if (!this.baseURL) return;
    this.dispatch(ChildProfileAction.clearChildProfileReducer());
    const reqBody = {
      stationId: 2,
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      childCode: childCode,
      languageCode:
        this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(ChildProfileAction.getChildProfileRequest(requestPayload));
  }

  /**
   * Fetches child profile data filtered by selected years for a given station and child code.
   * Dispatches actions to clear previous profile data and request new data.
   */
  async getChildProfileDatafilterbyYear(stationId, childCode, selectedYears = []) {
    if (!this.baseURL) return;
    this.dispatch(ChildProfileAction.clearChildProfileReducer());
    const reqBody = {
      stationId: stationId,
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      childCode: childCode,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
      YearFilterEnabled: true,
      selectedYears: selectedYears.length > 0 ? selectedYears.join(",") : "",
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(ChildProfileAction.getChildProfileRequest(requestPayload));
  }

  /**
   * Fetches donation options and dispatches the request.
   */
  async getDonateData() {
    if (!this.baseURL) return;
    this.dispatch(GiveAction.showGiveReducerLoading());
    const requestPayload = {
      baseURL: this.baseURL,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(GiveAction.getDonateRequest(requestPayload));
  }

  /**
   * Fetches "Give a Gift" options for a specific child.
   */
  async getGiveAGiftData(childCode) {
    if (!this.baseURL) return;
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      childCode: childCode,
      languageCode:
        this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(GiveAction.getGiveAGiftRequest(requestPayload));
  }

  /**
   * Fetches community and country data for a given station and child.
   */
  async getCommunityCountryData(stationId, childCode) {
    if (!this.baseURL) return;
    this.dispatch(CommunityAction.clearCommunityCountryReducer());
    const reqBody = {
      stationId: stationId,
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      childCode: childCode,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(CommunityAction.getCommunityCountryRequest(requestPayload));
  }

  /**
   * Fetches station data for a given station and child.
   */
  async getStationData(stationId, childCode) {
    if (!this.baseURL) return;
    this.dispatch(StationAction.clearStationCountryReducer());
    this.dispatch(StationAction.showStationCountryReducer());
    const reqBody = {
      stationId: stationId,
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      childCode: childCode,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(StationAction.getStationCountryRequest(requestPayload));
  }

  /**
   * Fetches "My Givings" data, including tax receipts and donation history.
   */
  async getMyGivingsData() {
    if (!this.baseURL) return;
    this.dispatch(MyGivingsAction.clearMyGivingsReducer());
    const reqBody = {
      sponsorID: this.persistItemsReducer?.sponsorID,
      languageCode:
        this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(MyGivingsAction.getMyGivingsRequest(requestPayload));
  }

  /**
   * Updates the status of content items (e.g., marks them as read or viewed).
   */
  async updateContentStatus(contentIds, interactionType = "READ") {
    if (!this.baseURL) return;
    const reqBody = {
      sponsorID: this.persistItemsReducer?.sponsorID,
      contentId: contentIds,
      interactionType: interactionType,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(StationAction.updateContentStatusRequest(requestPayload));
  }

  /**
   * Fetches user details from the server.
   * @returns {Promise<void>} Resolves when the request is dispatched.
   */
  async getUserData() {
    if (!this.baseURL) return;
    this.dispatch(UserDetailsAction.clearUserDetailsReducer());
    this.dispatch(UserDetailsAction.showUserDetailsReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      languageCode:
        this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(UserDetailsAction.getUserDetailsRequest(requestPayload));
  }

  /**
   * Fetches the user's cookie preferences.
   */
  async getCookiePreference() {
    if (!this.baseURL) return;
    this.dispatch(getCookiePreferenceAction.clearCookiePreferenceReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(getCookiePreferenceAction.getCookiePreferenceRequest(requestPayload));
  }

  /**
   * Updates the user's cookie preferences.
   */
  async updateCookiePreference(cookiesPreferenceEnabled) {
    if (!this.baseURL) return;
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      cookiesPreferenceEnabled: cookiesPreferenceEnabled,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(updateCookiePreferenceAction.updateCookiePreferenceRequest(requestPayload));
  }

  /**
   * Updates the timestamp for when the supporter contact details notification was last shown.
   */
  async updateSupporterNotification() {
    if (!this.baseURL) return;
    this.dispatch(UserDetailsAction.clearUserDetailsReducer());
    this.dispatch(UserDetailsAction.showUserDetailsReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      lastShownNotificationDateTime: moment().format(),
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(UpdateSupportNotificationAction.updateSupporterContactDetailsNotificationRequest(requestPayload));
  }

  /**
   * Fetches base64-encoded images from a list of URLs.
   */
  async getImageConvertData(imageUrls) {
    if (!this.baseURL) return;
    this.dispatch(ImageConvertAction.clearImageConvertReducer());
    this.dispatch(ImageConvertAction.showImageConvertReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      urls: imageUrls,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(ImageConvertAction.getImageConvertRequest(requestPayload));
  }

  /**
 * Fetches the profile for a dropped child.
 */
  async getDroppedChildProfile(childCode) {
    if (!this.baseURL) return;
    this.dispatch(DroppedChildAction.clearDroppedChildProfileReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      childCode: childCode,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(DroppedChildAction.getDroppedChildProfileRequest(requestPayload));
  }

  /**
   * Updates the user's phone number.
   *
   */
  async editPhoneNumber(number) {
    if (!this.baseURL) return;
    this.dispatch(EditPhoneAction.clearPhoneNumberReducer());
    const reqBody = {
      sponsorId: this.persistItemsReducer?.sponsorID,
      phoneNumber: number,
      languageCode:
        this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(EditPhoneAction.getPhoneNumberRequest(requestPayload));
  }

  /**
   * Updates the user's profile picture.
   *
   */
  async editProfilePicture(imageBase64) {
    if (!this.baseURL || !imageBase64) return;
    this.dispatch(EditPictureAction.clearProfilePictureReducer());
    const reqBody = {
      sponsorId: this.persistItemsReducer?.sponsorID,
      profilePictureAsBase64String: imageBase64,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(EditPictureAction.getProfilePictureRequest(requestPayload));
  }

  /**
   * Removes the user's profile picture.
   */
  async removeProfilePicture(imageBase64) {
    if (!this.baseURL) return;
    this.dispatch(EditPictureAction.clearProfilePictureReducer());
    const reqBody = {
      sponsorId: this.persistItemsReducer?.sponsorID,
      profilePictureAsBase64String: imageBase64,
      isPicRemoval: true,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(EditPictureAction.getProfilePictureRequest(requestPayload));
  }

  /**
   * Fetches details for a "Chosen" reveal.
   */
  async getChosenRevealDetails() {
    if (!this.baseURL) return;
    this.dispatch(getChosenRevealDetailsAction.clearChosenRevealDetailsReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(getChosenRevealDetailsAction.getChosenRevealDetailsRequest(requestPayload));
  }

  /**
   * Submits a request to delete the user's online account.
   */
  async submitDeleteAccount() {
    if (!this.baseURL) return;
    const { emailFrom, emailTo, emailCc, body, subject } = this.loginReducer?.getSOConfiguration?.deleteAccountSettings || {};
    const reqBody = {
      emailFrom,
      emailTo,
      emailCc,
      donorId: this.persistItemsReducer?.sponsorID,
      body,
      subject,
    };
    this.dispatch(PrivacyAction.showPrivacyReducer());
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(PrivacyAction.submitDeleteAccountRequest(requestPayload));
  }

  /**
   * Fetches details for a past sponsored child.
   */
  async getPastSponsoredChildDetails(childCode) {
    if (!this.baseURL) return;
    this.dispatch(PastSponsoredChildAction.clearPastSponsoredChildReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      childCode: childCode,
      languageCode:
        this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
      numberOfDays: 14,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(PastSponsoredChildAction.getPastSponsoredChildRequest(requestPayload));
  }

  /**
   * Updates the user's notification preferences.
   */
  async updateNotificationPreference(preferences) {
    if (!this.baseURL) return;

    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      ...preferences,
    };

    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };

    this.dispatch(UpdateNotificationAction.updateNotificationMediumPreferenceRequest(requestPayload));
  }

     /**
   * Fetches news stories and highlights.
   */
  async getNewsStories(numberOfStories, numberOfHighlights) {
    if (!this.baseURL) return;
    const reqBody = {
      requiredNumberOfStories: numberOfStories,
      requiredNumberOfHighlights: numberOfHighlights,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.loginReducer?.getSOConfiguration?.soBaseUrl,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    // dispatch action in redux call
    this.dispatch(GetStoriesAction.getStoriesRequest(requestPayload));
  }

  /**
   * Submits user feedback to the server.
   * @param {string} messageFeedback - The feedback message.
   * @param {array} metaList - A list of metadata related to the feedback.
   * @returns {Promise<void>} Resolves when the request is dispatched.
   */
  async submitFeedback(messageFeedback, metaList) {
    const reqBody = {
      sponsorID: this.persistItemsReducer?.sponsorID,
      feedbackMessage: messageFeedback,
      feedbackMetaDataList: metaList,
      emailFrom: this.loginReducer?.getSOConfiguration?.feedbackEmailSettings?.emailFrom || "",
      emailTo: this.loginReducer?.getSOConfiguration?.feedbackEmailSettings?.emailTo || "",
      emailCc: this.loginReducer?.getSOConfiguration?.feedbackEmailSettings?.emailCc || "",
      emailBcc: this.loginReducer?.getSOConfiguration?.feedbackEmailSettings?.emailBcc || "",
      subject: this.loginReducer?.getSOConfiguration?.feedbackEmailSettings?.subject || "",
      body: this.loginReducer?.getSOConfiguration?.feedbackEmailSettings?.body || "",
    };

    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };

    this.dispatch(GetHelpAction.showGetHelpReducer());
    this.dispatch(GetHelpAction.submitFeedbackRequest(requestPayload));
  }


  /**
   * Fetches FAQ data.
   */
  async getHelpFAQ(replaceValuesFormatted) {
    const soBaseUrl = this.loginReducer?.getSOConfiguration?.soBaseUrl;
    if (!soBaseUrl) return;

    this.dispatch(GetHelpAction.clearGetHelpReducer());
    this.dispatch(GetHelpAction.showGetHelpReducer());

    const reqBody = {
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
      placeHolders: this.loginReducer?.getSOConfiguration?.faqFormatter?.placeHolders,
      replaceValues: replaceValuesFormatted,
      FAQType: "All",
    };
    const requestPayload = {
      baseURL: soBaseUrl,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(GetHelpAction.getHelpFAQRequest(requestPayload));
  }
  /* Update ChosenChild Explore Status */
    async updateChosenChildExploreStatus(childCode) {
    if (!this.baseURL) return;
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      childCodes: childCode
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };

    this.dispatch(UpdateChosenChildExploreStatusAction.updateChosenChildExploreStatusRequest(requestPayload));
  }
}

export default ApiRepository;